export default __webpack_public_path__ + "static/media/679.25436ce1.jpg";